import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { money } from "@/lib/api";
import { Label, StarRating } from "@/components/Badges";

export default function LocalCard({ o, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: (index % 4) * 0.05 }}
      className="group"
      data-testid={`local-card-${o.slug}`}
    >
      <Link to={`/local/${o.slug}`} className="block bg-white rounded-2xl overflow-hidden friib-shadow hover:friib-shadow-hover transition-all duration-300 hover:-translate-y-1 border border-stone-100">
        <div className="relative aspect-[4/3] overflow-hidden bg-stone-50">
          <img src={o.image} alt={o.title} loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
          <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
            {(o.labels || []).slice(0, 2).map((l) => <Label key={l}>{l}</Label>)}
          </div>
          <div className="absolute bottom-3 left-3 flex items-center gap-1 text-white text-xs font-semibold">
            <MapPin size={13} /> {o.distance} mi away
          </div>
        </div>
        <div className="p-4">
          <div className="flex items-center justify-between mb-1">
            <span className="text-xs font-bold uppercase tracking-wider text-stone-500">{o.business_name}</span>
            <StarRating rating={o.business_info?.rating} size={12} />
          </div>
          <h3 className="font-display font-bold text-lg text-stone-900 leading-snug mb-1">{o.title}</h3>
          <p className="text-sm text-stone-500 mb-3">Up to {money(o.normal_value)} value · {o.purchase_requirement}</p>
          <div className="flex items-center justify-between">
            <span className="px-3 py-1 rounded-full text-sm font-extrabold text-white" style={{ background: "var(--mint)" }}>FRIIB</span>
            <span className="text-xs font-semibold text-stone-400">{o.inventory_remaining} left</span>
          </div>
          <div className="mt-3 w-full text-center py-2.5 rounded-full font-bold text-white text-sm"
            style={{ background: "var(--ink)" }}>Claim Friib</div>
        </div>
      </Link>
    </motion.div>
  );
}
